import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as dealerDiscountsSelectors from '@makemydeal/dr-dash-store/selectors/dealerDiscountsSelectors';
import type { DealHistory, StateTree } from '@makemydeal/dr-dash-types';
import { useMemo } from 'react';
import { useDealSummary } from '../../common/DealSummaryProvider';
import * as constants from '../../constants';
import DealSummaryItem from '../common/DealSummaryItem';
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

export type DiscountsOptions = {
    deal?: DealHistory;
    hasDelta?: boolean;
    showNegativeDiscount?: boolean;
};

export const Discount = (discountsOptions: DiscountsOptions) => {
    const { deal, hasDelta = false } = discountsOptions;

    const selectDiscount = useMemo(() => (state: StateTree) => dealerDiscountsSelectors.getSummaryDiscount(state, deal), [deal]);

    const discount = useTrackedSelector(selectDiscount, { component: 'Discount', field: 'discount' });

    const isPositive = discount != null && discount >= 0;

    const { showDetailedView } = useDealSummary();

    const discountLabel = isPositive ? constants.DISCOUNT : constants.MARKUP;

    return discount != null ? (
        <DealSummaryItem
            label={discountLabel}
            value={formatDollarsAndCents(Math.abs(discount))}
            hasDelta={hasDelta}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    ) : null;
};

export default Discount;
